<app-detail-main-template>
  <div container-header>
    <div class="header bold">PROJECTS</div>
    <div class="statistics">
      <app-header-statistics [headerStatistics]="projectStatsList"></app-header-statistics>
    </div>
    <div class="filters">

      <div class="text-right">
        <app-button data-qa="create-bulk-projects"
                    text="CREATE BULK PROJECTS"
                    class="createBulkProjects"
                    [routerLink]="['/project/bulkupload']"></app-button>
        <app-button data-qa="create-new-project"
                    text="CREATE NEW PROJECT"
                    (click)="changeNewProjectDialog()">
        </app-button>
      </div><br>
      <div class="text-right archiveProjects">
        <app-button data-qa="view-archived-projects"
                    text="VIEW ARCHIVED PROJECTS"
                    [routerLink]="['/project/projectfiles']"></app-button>
      </div>
    </div>
    <div>
      <app-new-project #newProjectComponent [isNewProjectVisible]="isNewProjectView" [hasClientOrgsOptions]="true" [hasProductTypesOptions]="true" 
                       (formClose)="createProject($event)">
      </app-new-project>
    </div>
  </div>
  <div container-body>
    <div>
      <app-server-grid [configuration]="serverGridConfiguration"
                       [(request)]="serverRequest"
                       [(selection)]="serverGridSelection"
                       [filterTemplate]="filterForm"
                       [actionTemplate]="projectActionTemplate">

        <ng-template #projectActionTemplate let-rowData let-localActionPopover="actionPopover">
          <div class="action-template-container">
            <ng-container *ngFor="let action of threeDotActions; trackBy: trackByIndex">
              <app-button *ngIf="action.isVisible(rowData)"
                          [text]="action.name"
                          (onClick)="action.action(rowData); localActionPopover.hide();"
                          [disabled]="action.disabled"></app-button>
            </ng-container>
          </div>
        </ng-template>

        <ng-template #filterForm
                     let-form>
          <app-tab-menu orientation="left">
            <app-tab-panel header="Project(s)">
              <div class="p-col-12 p-md-12 p-lg-12">
                <form-factory [formGroup]="form"
                              [model]="projectsInput"></form-factory>
              </div>
            </app-tab-panel>
            <app-tab-panel header="Project ID">
              <div class="p-col-12 p-md-12 p-lg-12">
                <form-factory [formGroup]="form"
                              [model]="projectIdInput"></form-factory>
              </div>
            </app-tab-panel>

            <app-tab-panel header="Status">
              <div class="p-col-12 p-md-12 p-lg-12">
                <form-factory [formGroup]="form"
                              [model]="projectStatusInput"></form-factory>
              </div>
            </app-tab-panel>

            <app-tab-panel header="Group(s)">
              <div class="p-col-12 p-md-12 p-lg-12">
                <form-factory [formGroup]="form"
                              [model]="clientsInput"></form-factory>
              </div>
            </app-tab-panel>
            <app-tab-panel header="Product(s)">
              <div class="p-col-12 p-md-12 p-lg-12">
                <form-factory [formGroup]="form"
                              [model]="productsInput"></form-factory>
              </div>
            </app-tab-panel>
          </app-tab-menu>
        </ng-template>

      </app-server-grid>

      <app-modal [(visible)]="cloneProjectModalVisible"
                 header="CLONE PROJECT"
                 class="project-clone-modal">
        <label>PROJECT NAME</label>
        <div class="project-clone-modal--inputbox">
          <input type="text" pInputText placeholder="Enter Name" [(ngModel)]="filename" />
        </div>
        <footer>
          <app-button class="header-button" text="SAVE" (onClick)="cloneProject()" [disabled]="!fileNameAvailable"></app-button>
        </footer>
      </app-modal>
    </div>
    
  </div>
</app-detail-main-template>
